/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiWaveLog {
    'id': string;
    'action': string;
    'wave_id': string;
    'drop_id': string;
    'drop_author'?: ApiProfileMin;
    'invoker': ApiProfileMin;
    'invoker_proxy'?: ApiProfileMin;
    'created_at': Date;
    'contents': { [key: string]: any; };

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "string",
            "format": ""
        },
        {
            "name": "wave_id",
            "baseName": "wave_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "drop_id",
            "baseName": "drop_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "drop_author",
            "baseName": "drop_author",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "invoker",
            "baseName": "invoker",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "invoker_proxy",
            "baseName": "invoker_proxy",
            "type": "ApiProfileMin",
            "format": ""
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "contents",
            "baseName": "contents",
            "type": "{ [key: string]: any; }",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiWaveLog.attributeTypeMap;
    }

    public constructor() {
    }
}

